import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { CreateTimeWindowGroupDto, TimeWindowGroupDto } from "../../../models/time-window/dto/time-window.dto";
import { GET_TIME_WINDOW_GROUPS_QUERY_KEY } from "./useGetTimeWindowGroups";

export const useCreateTimeWindowGroup = (onSuccess?: (data: TimeWindowGroupDto) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationKey: ['createTimeWindowGroup'],
        mutationFn: (dto: CreateTimeWindowGroupDto) =>
            client.fetchApi<TimeWindowGroupDto, CreateTimeWindowGroupDto>({
                endpoint: 'time-windows/groups',
                method: 'POST',
                body: dto
            }),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: GET_TIME_WINDOW_GROUPS_QUERY_KEY() });
            onSuccess?.(data);
        },
        onError: () => {
            toast({ title: translate('time_windows.create_group_error'), status: 'error' });
        }
    });
};